module.exports = __webpack_public_path__ + "static/media/upgrade-banner-blue@3x.970e3234.png";